import { FC } from 'react';

import { css } from '@emotion/react';
import { ToucanComponents } from '@jointoucan/toucan-design';
import { useTheme } from '@mui/material';

import Divider from '~/components/shared/Divider';

const { Typography } = ToucanComponents;

interface MainProps {
  title?: string;
  contentMaxWidth?: number;
}

const Main: FC<MainProps> = ({ children, title, contentMaxWidth = 768 }) => {
  const theme = useTheme();

  return (
    <main
      css={css`
        display: flex;
        flex: 1;
      `}
    >
      <div
        css={css`
          overflow-y: auto;
          padding: ${theme.spacing(4)} ${theme.spacing(2)};
          width: 100%;
          ${theme.breakpoints.up('sm')} {
            padding: ${theme.spacing(4)};
          }
        `}
      >
        {title && (
          <>
            <Typography
              variant="lg"
              font="secondary"
              css={css`
                margin-bottom: ${theme.spacing(2)};
              `}
            >
              {title}
            </Typography>
            <Divider
              css={css`
                width: 100%;
                margin-bottom: ${theme.spacing(4)};
              `}
            />
          </>
        )}

        <div
          css={css`
            width: 100%;
            max-width: ${contentMaxWidth}px;
            display: flex;
            flex-direction: column;
          `}
        >
          {children}
        </div>
      </div>
    </main>
  );
};

export default Main;
